import { FolderOpenFilled } from '@ant-design/icons'
import { AgentClient } from '~/agents/common/client/agent'
import { LegalAssistantCommon } from '../common'

export const LegalAssistantAgent: AgentClient = {
  key: LegalAssistantCommon.Agent.key,
  getTabs: ({ appSession, pathBase }) => [
    {
      to: `${pathBase}/legal-documents`,
      icon: <FolderOpenFilled />,
      label: 'Legal Documents',
    },
  ],
}
